export default __webpack_public_path__ + "assets/7bd062f9c665a0e80d0aff2cec96b126.png";